import * as fromDatatype from '../datatype-library/index';

export interface app_login_provider_hdr_RowInterface {
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
}

export class app_login_provider_hdr_RowClass implements app_login_provider_hdr_RowInterface {
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
}


